import type { SVGProps } from 'react';

const ImageComplianceIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    {...props}
  >
    <path
      d="M22.6756 47.7005H14.4443C8.92148 47.7005 4.44434 43.2233 4.44434 37.7005V36.5591M40.907 24.4049V11.1094C40.907 5.58653 36.4298 1.10938 30.907 1.10938H14.4443C8.92149 1.10938 4.44434 5.58652 4.44434 11.1094V36.5591M4.44434 36.5591L9.12602 31.8775C10.7558 30.2476 13.3802 30.1906 15.0793 31.7481V31.7481C16.7784 33.3056 19.4027 33.2486 21.0325 31.6187L27.7399 24.9114C29.9774 22.6738 33.6052 22.6738 35.8427 24.9114V24.9114"
      stroke="#112A55"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="15.5856"
      cy="17.3131"
      r="3.0514"
      stroke="#112A55"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M41.1795 58.3746C49.1616 58.3746 55.6324 51.9038 55.6324 43.9217C55.6324 35.9395 49.1616 29.4688 41.1795 29.4688C33.1973 29.4688 26.7266 35.9395 26.7266 43.9217C26.7266 51.9038 33.1973 58.3746 41.1795 58.3746Z"
      stroke="#2563EB"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M34.9668 44.2997L37.1445 46.7496C38.3245 48.0772 40.3988 48.0772 41.5789 46.7496L48.1514 39.3555"
      stroke="#2563EB"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ImageComplianceIcon;
